var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsx, jsxs } from "react/jsx-runtime";
import * as React from "react";
import "../../Utilities.js";
import { Stack } from "@fluentui/react/lib/Stack";
import { Text } from "@fluentui/react/lib/Text";
import { ActionButton } from "@fluentui/react/lib/Button";
import "../Icon/index.js";
import "../../Styling.js";
import "../../FocusZone.js";
import { SuccessIcon } from "../Icon/SuccessIcon.js";
import { getClassNames } from "./Accordion.styles.js";
import "../OverflowSet.js";
import { warnDeprecations, getId } from "@fluentui/utilities";
import { getTheme, mergeStyles } from "@fluentui/style-utilities";
import { FocusZone } from "@fluentui/react-focus";
import { Icon } from "../Icon/Icon.js";
import { OverflowSet } from "@fluentui/react/lib/OverflowSet";
const COMPONENT_NAME = "Accordion";
class Accordion extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "_toggleContent", (ev) => {
      var _a;
      const { isExpanded } = this.props;
      const defaultExpanded = typeof isExpanded === "boolean" ? !isExpanded : !this.state.isExpanded;
      ((_a = this.props) == null ? void 0 : _a.onToggle) && this.props.onToggle(ev, defaultExpanded);
      if (!(ev == null ? void 0 : ev.defaultPrevented)) {
        this.setState({ isExpanded: defaultExpanded });
      }
    });
    __publicField(this, "_onRenderHeader", (props) => {
      if (!props)
        return null;
      const { styles, ariaLabel, header, id, successIconProps, hasError, overflowSetProps, isExpanded } = props;
      const defaultExpanded = typeof isExpanded === "boolean" ? isExpanded : this.state.isExpanded;
      const theme = getTheme();
      const classNames = getClassNames(this.props, theme, styles, defaultExpanded);
      const contentId = `${id}-content`;
      return /* @__PURE__ */ jsx(FocusZone, { children: /* @__PURE__ */ jsxs(Stack, { horizontal: true, children: [
        /* @__PURE__ */ jsx(
          ActionButton,
          {
            className: classNames.link,
            onClick: this._toggleContent,
            "aria-expanded": defaultExpanded,
            "aria-controls": contentId,
            ariaLabel: ariaLabel ? ariaLabel : header,
            children: /* @__PURE__ */ jsxs(Stack, { className: classNames.header, horizontal: true, verticalAlign: "center", children: [
              /* @__PURE__ */ jsx(Icon, { "aria-hidden": true, ariaLabel, className: classNames.icon, iconName: "ChevronDown" }),
              successIconProps && /* @__PURE__ */ jsx(SuccessIcon, __spreadProps(__spreadValues({}, successIconProps), { ariaLabel: "" })),
              /* @__PURE__ */ jsx(Text, { className: classNames.headerText, children: header }),
              hasError && /* @__PURE__ */ jsx(Icon, { ariaLabel: `${ariaLabel}-Error`, className: classNames.alert, iconName: "ErrorBadge" })
            ] })
          }
        ),
        !!overflowSetProps && /* @__PURE__ */ jsx(OverflowSet, __spreadValues({ className: mergeStyles(classNames.link, { flexGrow: 0 }) }, overflowSetProps))
      ] }) });
    });
    warnDeprecations(COMPONENT_NAME, props, {
      showContentOnRender: "defaultExpanded"
    });
    this.state = {
      isExpanded: !!props.showContentOnRender || !!props.defaultExpanded
    };
  }
  render() {
    const theme = getTheme();
    const _a = this.props, {
      styles,
      ariaLabel,
      children,
      className,
      header,
      id = getId("Accordion"),
      showContentOnRender,
      isExpanded,
      successIconProps,
      hasError,
      overflowSetProps,
      onRenderHeader = this._onRenderHeader
    } = _a, rest = __objRest(_a, [
      "styles",
      "ariaLabel",
      "children",
      "className",
      "header",
      "id",
      "showContentOnRender",
      "isExpanded",
      "successIconProps",
      "hasError",
      "overflowSetProps",
      "onRenderHeader"
    ]);
    const defaultExpanded = typeof isExpanded === "boolean" ? isExpanded : this.state.isExpanded;
    const classNames = getClassNames(this.props, theme, styles, defaultExpanded);
    const contentId = `${id}-content`;
    return /* @__PURE__ */ jsxs("div", __spreadProps(__spreadValues({}, rest), { className: classNames.accordion, id, children: [
      onRenderHeader(__spreadProps(__spreadValues({}, this.props), { id }), this._onRenderHeader),
      /* @__PURE__ */ jsx(Stack, { id: contentId, className: classNames.content, "aria-hidden": !defaultExpanded, children: /* @__PURE__ */ jsx("div", { className: classNames.contentContainer, children }) })
    ] }));
  }
}
export {
  Accordion
};
//# sourceMappingURL=Accordion.js.map
